import { render } from "./Badge.vue?vue&type=template&id=bae145de&ts=true"
import script from "./Badge.vue?vue&type=script&setup=true&lang=ts"
export * from "./Badge.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/badge/Badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bae145de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bae145de', __exports__)) {
    api.reload('bae145de', __exports__)
  }
  
  module.hot.accept("./Badge.vue?vue&type=template&id=bae145de&ts=true", () => {
    api.rerender('bae145de', render)
  })

}


export default __exports__